import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";

const HERO_IMAGE = "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=900&q=80";

export const LoginHero = () => {
  const { t } = useTranslation();
  const features = [t("login.feat1"), t("login.feat2"), t("login.feat3"), t("login.feat4")];
  return <div className="w-full md:w-1/2 relative overflow-hidden flex items-center justify-center bg-card border-b md:border-b-0 md:border-r border-border py-10 md:py-0 md:min-h-full">
    <img src={HERO_IMAGE} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
    <div className="absolute inset-0 bg-gradient-to-br from-background/90 via-background/60 to-primary/10" />
    <div className="relative z-10 px-12 text-center space-y-6">
      <div className="w-20 h-20 mx-auto rounded-2xl bg-primary/20 border border-primary/40 flex items-center justify-center shadow-lg shadow-primary/10">
        <Sparkles className="w-9 h-9 text-primary" />
      </div>
      <div>
        <h1 className="text-3xl font-bold text-foreground leading-tight">Skinly<br /><span className="text-primary">Check</span></h1>
        <p className="text-muted-foreground mt-3 text-sm leading-relaxed max-w-xs mx-auto">{t("login.tagline")}</p>
      </div>
      <div className="space-y-3 text-left max-w-xs mx-auto">
        {features.map((feature) => <div key={feature} className="flex items-start gap-2.5">
          <div className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 shrink-0" />
          <p className="text-xs text-muted-foreground">{feature}</p>
        </div>)}
      </div>
    </div>
  </div>;
};

export const LoginFooterLinks = () => {
  const { t } = useTranslation();
  return <div className="border-t border-border pt-5 text-center space-y-2">
    <p className="text-sm text-foreground">
      {t("login.firstTime")}{" "}
      <a href="/register" className="text-primary font-semibold hover:underline" data-testid="login-register-link">{t("login.register")}</a>
    </p>
    <p className="text-xs text-muted-foreground">
      {t("login.boughtNoEmail")}{" "}
      <a href="/resend-setup" className="text-primary hover:underline" data-testid="login-resend-link">{t("login.resend")}</a>
    </p>
    <p className="text-xs text-muted-foreground">
      {t("login.haveProblems")}{" "}
      <a href="mailto:mentoriafabioborges@gmail.com" data-testid="login-support" className="text-primary hover:underline">{t("common.supportEmail")}</a>
    </p>
  </div>;
};
